<template>
  <v-card class="ma-6">
    <v-card-title>
      <v-icon color="primary" class="mr-6">mdi-alert-circle-outline</v-icon>
      Errors
      <div class="flex-grow-1"></div>
      <v-text-field color="green" v-model="search" append-icon="search" label="Search by any field" single-line
        hide-details></v-text-field>
    </v-card-title>

    <v-card-text>
      <v-row dense align="center">
        <v-col cols="12" sm="4" md="3">
          <v-text-field v-model="from" type="datetime-local" label="From" hide-details dense></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-text-field v-model="to" type="datetime-local" label="To" hide-details dense></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-btn small text color="primary" @click="clearDates">Clear dates</v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-data-table dense :headers="headers" :options.sync="options" :items="items"
      :server-items-length="totalItems" :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100, 500, -1]
      }" loading-text="Loading...please wait" :loading="loading">

      <template v-slot:item.eventDateTime="{ item }">
        {{ formatDateTime(item.eventDateTime) }}
      </template>

      <template v-slot:item.description="{ item }">
        <div class="truncated-message">{{ item.description }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn small icon @click="showMessage(item)" title="View full message">
          <v-icon small>mdi-open-in-new</v-icon>
        </v-btn>
      </template>

    </v-data-table>

    <v-dialog v-model="dialog" max-width="1600px">
      <v-card>
        <v-card-title>
          <v-icon color="primary" class="mr-3">mdi-alert-circle-outline</v-icon>
          Error details
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle v-if="selectedItem">
          {{ selectedItem.component }} &mdash; {{ formatDateTime(selectedItem.eventDateTime) }}
        </v-card-subtitle>
        <v-card-text>
          <pre class="message-pre">{{ selectedItem ? selectedItem.description : '' }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ApplicationEventsService } from '../services/api/applicationEvents';
import _ from "lodash";
import moment from "moment";

const apiApplicationEvents = new ApplicationEventsService();

export default {
  data() {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      options: {},
      search: '',
      from: '',
      to: '',
      dialog: false,
      selectedItem: null,

      headers: [
        { text: 'ID', value: 'id', align: ' d-none' },
        { text: 'Date / Time', value: 'eventDateTime' },
        { text: 'Component', value: 'component' },
        { text: 'Message', value: 'description', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' },
      ],
    }
  },

  watch: {
    options: {
      handler() {
        this.loadItems()
      },
      deep: true,
    },
    search: function () {
      this.debouncedloadItems();
    },
    from: function () {
      this.debouncedloadItems();
    },
    to: function () {
      this.debouncedloadItems();
    },
  },

  created: function () {
    this.debouncedloadItems = _.debounce(this.loadItems, 500);

    // Initialize the date range from the query string (used by the daily report email link).
    this.from = this.toInputDateTime(this.$route.query.from);
    this.to = this.toInputDateTime(this.$route.query.to);
  },

  methods: {
    // Convert an ISO date string to the "YYYY-MM-DDTHH:mm" format required by datetime-local inputs.
    toInputDateTime(value) {
      if (!value) {
        return '';
      }
      const m = moment(value);
      return m.isValid() ? m.format('YYYY-MM-DDTHH:mm') : '';
    },

    formatDateTime(value) {
      if (!value) {
        return '';
      }
      return moment(value).format('MM/DD/YY h:mm:ss A');
    },

    clearDates() {
      this.from = '';
      this.to = '';
    },

    showMessage(item) {
      this.selectedItem = item;
      this.dialog = true;
    },

    loadItems() {
      this.loading = true;
      this.getApplicationEvents();
    },

    getApplicationEvents() {
      this.loading = true;
      this.items = [];

      const search = {
        searchText: this.search,
        sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "EventDateTime",
        sortDirection: this.options.sortDesc.length == 0 ? "desc" : (this.options.sortDesc[0] ? "desc" : "asc"),
        itemsPerPage: this.options.itemsPerPage,
        itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),
      };

      apiApplicationEvents
        .getApplicationEvents(search, {
          from: this.from || undefined,
          to: this.to || undefined,
        })
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.totalItemCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
}
</script>

<style scoped>
.truncated-message {
  max-width: 1000px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.message-pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: "Consolas", "Courier New", monospace;
  font-size: 13px;
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  margin: 0;
}
</style>
